import { defineNuxtPlugin } from '#app';
import * as iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';

export default defineNuxtPlugin((nuxtApp) => {
    if (!('$toast' in nuxtApp)) {
        nuxtApp.provide('toast', iziToast);
    }
});
